import Cribbage from '../../CribbageCore/src/Game/Cribbage.js';
import Statistics from '../../CribbageCore/src/Statistics.js';
import Level from '../../CribbageCore/src/Level.js';


import Audio from './Audio.js';

import GameServer from './GameServer.js'



import Items from './Items.js';


import { Analytics } from '@cardsjd/analytics';
import { Device } from '@cardsjd/device';
import { EmailFeedback } from '@cardsjd/emailfeedback';
import { RateApp } from '@cardsjd/rateapp';
import { Share } from '@cardsjd/share';
import { IAP } from '@cardsjd/iap';
import { PushNotification } from '@cardsjd/pushnotification';
import { MarketPlace } from '@cardsjd/marketplace';
import { Storage } from '@cardsjd/storage';
import { Advertisement } from '@cardsjd/advertisement';
import { AccountJD } from '@cardsjd/accountjd';
import { Gamification } from '@cardsjd/gamification';
//import { FBInstantGame } from '@cardsjd/fbinstantgame';
import { Prompter } from '@cardsjd/prompter';
import { Achievements } from '@cardsjd/achievements';
import { Localization } from '@cardsjd/localization';

//Game portals
import { Portal } from './portals/Portal.js';

//configs
import AdvertisementConfig from './configs/AdvertisementConfig.js';
import AchievementConfig from './configs/AchievementConfig.js';
import LocalizationConfig from './configs/LocalizationConfig.js';
import AppConfig from './configs/AppConfig.js';
import StoreConfig from './configs/StoreConfig.js';

//import AnalyticsFireBase from './AnalyticsFireBase.js';



import Test from './Test.js';
import Blacklist from './Blacklist.js';


import DataBinder from "./DataBinder.js";
import SwapPage from "./SwapPage.js";

import Router from "./Router.js";
import BasicController from './Controllers/BasicController.js';
import LevelController from './Controllers/LevelController.js';
import MainMenuController from './Controllers/MainMenuController.js';
import FindServerController from './Controllers/FindServerController.js';
import ProfileController from './Controllers/ProfileController.js';
import StoreController from './Controllers/StoreController.js';
import IAPMenuController from './Controllers/IAPMenuController.js';
import AvatarController from './Controllers/AvatarController.js';
import BoardController from './Controllers/BoardController.js';
import DeckController from './Controllers/DeckController.js';
import BackgroundController from './Controllers/BackgroundController.js';
import GameHistoryController from './Controllers/GameHistoryController.js';
import LeaderboardController from './Controllers/LeaderboardController.js';
import LeaderboardsController from './Controllers/LeaderboardsController.js';
import LeaderboardRatingController from './Controllers/LeaderboardRatingController.js';
import LeaderboardWinRateController from './Controllers/LeaderboardWinRateController.js';
import LeaderboardPointSpreadController from './Controllers/LeaderboardPointSpreadController.js';
import LeaderboardDurationController from './Controllers/LeaderboardDurationController.js';

import OnlineController from './Controllers/OnlineController.js';
import FindPlayerController from './Controllers/FindPlayerController.js';
import StatisticsController from './Controllers/StatisticsController.js';
import AchievementsController from './Controllers/AchievementsController.js';
import RegisterController from './Controllers/RegisterController.js';
import LoginController from './Controllers/LoginController.js';
import LoginEmailController from './Controllers/LoginEmailController.js';
import GameController from './Controllers/GameController.js';
import MoreGamesController from './Controllers/MoreGamesController.js';
import ContactController from './Controllers/ContactController.js';


export default class App {
  constructor(window) {
    this.initialize(window);
  }
  async initialize(window) {
    this.config = AppConfig;
    this.dataBinder = new DataBinder(this);
    this.localization = new Localization(LocalizationConfig);
    this.items = new Items();
    this.achievements = new Achievements(AchievementConfig);

    this.statistics = new Statistics();
    this.level = new Level();
    this.userdata = {};
    this.appEvent = function () { };
    this.gameServer = new GameServer(this.config);
    this.storage = new Storage(this.config);
    this.cribbage = new Cribbage();
    this.analyticsJI = new Analytics(this.config);
    //this.analyticsFireBase = new AnalyticsFireBase(this.config.appName, this.config.version);
    this.marketPlace = new MarketPlace(this.config);
    this.rateApp = new RateApp(this.config);
    this.emailFeedback = new EmailFeedback(this.config);
    this.sharer = new Share(this.config);
    this.prompter = new Prompter(this.config);
    //this.fBInstantGame = new FBInstantGame(this.config);
    this.gamification = new Gamification(this.config);
    this.accountJD = new AccountJD(this.config);
    this.device = new Device();
    this.pushNotification = new PushNotification();
    this.test = new Test(this);
    this.IAP = new IAP(StoreConfig);
    this.audio = new Audio();
    this.advertisement = new Advertisement(AdvertisementConfig);
    this.blacklist = new Blacklist();
    this.router = new Router(this, null);
    //create portal
    this.portal = Portal.create(null, this.config, AdvertisementConfig);


    this.version = this.config.version || "3.4.0";
    this.debug = this.config.Debug || false;
    this.news = "";




    //get default resource
    this.resource = this.localization.getResource();

    //----init-----//
    //controllers and router
    this.controllers = {}
    this.controllers.GameHistory = new GameHistoryController(this);
    this.controllers.Level = new LevelController(this);
    this.controllers.MainMenu = new MainMenuController(this);
    this.controllers.FindServer = new FindServerController(this);
    this.controllers.Profile = new ProfileController(this);
    this.controllers.Store = new StoreController(this);
    this.controllers.IAPMenu = new IAPMenuController(this);
    this.controllers.Avatar = new AvatarController(this);
    this.controllers.Board = new BoardController(this);
    this.controllers.Deck = new DeckController(this);
    this.controllers.Background = new BackgroundController(this);
    this.controllers.Leaderboard = new LeaderboardController(this); //current Leaderboard, the Leaderboards are the new ones
    this.controllers.Leaderboards = new LeaderboardsController(this);
    this.controllers.LeaderboardRating = new LeaderboardRatingController(this);
    this.controllers.LeaderboardWinRate = new LeaderboardWinRateController(this);
    this.controllers.LeaderboardPointSpread = new LeaderboardPointSpreadController(this);
    this.controllers.LeaderboardDuration = new LeaderboardDurationController(this);
    this.controllers.Online = new OnlineController(this);
    this.controllers.FindPlayer = new FindPlayerController(this);
    this.controllers.Statistics = new StatisticsController(this);
    this.controllers.Achievements = new AchievementsController(this);
    this.controllers.Register = new RegisterController(this);
    this.controllers.Login = new LoginController(this);
    this.controllers.LoginEmail = new LoginEmailController(this);
    this.controllers.Game = new GameController(this);
    this.controllers.MoreGames = new MoreGamesController(this);
    this.controllers.Contact = new ContactController(this);


    this.router.controllers = this.controllers;
    this.router.defaultController = new BasicController(this);
    this.router.onRoute = this.onRoute.bind(this);
    this.router.route("Loading");

    //wire up achievements
    this.achievements.onNewAchievement = this.onNewAchievement.bind(this);

    //wire up IAP
    this.IAP.onBuy = this.onIAPBuy.bind(this);

    //share wire up events handlers
    this.prompter.onPrompt = this.onPrompt.bind(this);

    //notification wire up event handlers
    this.pushNotification.onTokenUpdated = this.onPushNotificationTokenUpdated.bind(this);
    this.pushNotification.onMessage = this.onNotificationMessage.bind(this);

    //wire up Advertisement
    this.advertisement.onAdRewarded = this.onAdRewarded.bind(this);
    this.advertisement.onAdLoaded = this.onAdLoaded.bind(this);
    this.advertisement.onAdOpened = this.onAdOpened.bind(this);



    this.device.onBackButton = this.onBackButton.bind(this);
    this.platform = this.device.getPlatform();
    console.log("Platform:", this.platform);


    //wire up socket event handlers
    this.gameServer.onDisconnect = this.onDisconnect.bind(this);
    this.gameServer.onReconnecting = this.onReconnecting.bind(this);
    this.gameServer.onErrorNetwork = this.onErrorNetwork.bind(this);
    this.gameServer.onLogin = this.onLoginNetwork.bind(this);
    this.gameServer.onJoin = this.onjoinGameNetwork.bind(this);
    this.gameServer.onLeave = this.onLeaveGameNetwork.bind(this);
    this.gameServer.onJoinRoom = this.onJoinRoomNetwork.bind(this);
    this.gameServer.onRoom = this.onRoomNetwork.bind(this);
    this.gameServer.onMessage = this.onMessageNetwork.bind(this);
    this.gameServer.onInvite = this.onInviteNetwork.bind(this);
    this.gameServer.onUserData = this.onUserDataNetwork.bind(this);
    this.gameServer.onStats = this.onStatsNetwork.bind(this);



    document.addEventListener("deviceready", async () => {
      console.log("deviceready--------");
      if (typeof cordova !== 'undefined' && typeof cordova.InAppBrowser !== 'undefined') {
        window.open = cordova.InAppBrowser.open;
      }
    }, false);



    this.audio.load('CardClick', 'assets/Audio/click_lower_volumn.wav');
    this.audio.load('PointSound', 'assets/Audio/whoop.wav');
    this.audio.load('AchivementSound', 'assets/Audio/chime.wav');
    this.audio.load('WinSound', 'assets/Audio/win.wav');

    this.navigate("Loading");
    this.newsLoad();

    //GameController could lazy load, but it currently does not support it.  It has race condition bug.  Use case, the contoller is requested 2x before it is loaded.  The 2nd request will fail.
    //Ideal: start loading in the background, and when the controller is requested, it will be ready, or it will wait for it to load.
    //let gameController = this.controllers.Game;
    //gameController.loadGame().then(() => {
    //this.loadData();
    //});

    let gameController = this.controllers.Game;
    //gameController.loadGameSafe(); //start loading the game in the background
    await gameController.loadGameSafe(); // wait for the game to load

    //todo: change to await and then call dataLoaded (could do all this in init?)
    await this.loadData();
  }
  async loadData() {
    console.log("app.loadData()");
    let data = await this.storage.load(this.config.storageName ?? "cribbage.userdata");

    this.userdata = data || {};

    //load and sync data from portal 
    await this.loadPortalData();

    await this.dataLoaded();
  }
  async loadPortalData() {
    const platform = this.platform;
    try {
      console.log(`Portal: Initializing - ${this.portal?.name}`);
      await this.portal.init();
      await this.portal.loadStart();
      const portalData = await this.portal.load();
      await this.portal.loadStop();

      //sync data from portal
      //merge portal userdata with local userdata
      //(could the sync logic be in the portal? each would decide what important to force or be optional)
      if (portalData?.userdata) {
        //get userdata from crazygames storage - and get newest data
        const pUserdata = portalData.userdata;
        let overwrite = false;
        if (pUserdata && !this.userdata?.name) overwrite = true;
        if (pUserdata && pUserdata.game_open > (this.userdata?.game_open || 0)) overwrite = true;
        if (pUserdata && pUserdata.id > 0 && pUserdata.id !== (this.userdata?.id || 0)) overwrite = true;
        if (overwrite) {
          this.userdata = pUserdata; //needs to be this.userdata to keep reference
        }
      }
      if (portalData?.user) {
        const pUser = portalData.user;
        //update name and avatar from portal info
        if (pUser?.name && (!this.userdata?.name || this.userdata.name?.startsWith("Player"))) this.userdata.name = pUser.name;
        if (pUser?.avatar && !this.userdata?.avatar) this.userdata.avatar = pUser.avatar;
        if (pUser?.avatar && platform === "crazygames") this.userdata.avatar = pUser.avatar; //force avatar on crazygames (could the sync logic be in the portal?)
        if (pUser?.facebookId) this.userdata.facebookId = pUser.facebookId;
        if (pUser?.crazyGamesId) this.userdata.crazyGamesId = pUser.crazyGamesId;

        //update avatar to server if needed
        this.updateAvatarToServer(platform);
      }
    } catch (e) {
      console.error("Portal load error", e);
    }
  }

  async dataLoaded() {
    console.log("app.dataLoaded()");

    //set defaults
    if (!this.userdata.name) {
      this.userdata.name = "Player" + Math.floor(Math.random() * 10000);
    }

    //set localization resource based on user settings
    if (this.userdata.language) {
      this.resource = this.localization.getResource(this.userdata.language);
    }
    //get random avatar if none
    if (!this.userdata.avatar) {
      this.userdata.avatar = this.avatarRandom();
    }
    //get device id if none
    if (!this.userdata.deviceId) {
      this.userdata.deviceId = this.device.getDeviceID();
    }

    //todo: may need to move join room to end init right before going to main menu, but skip login.

    //auto login from url
    const params = new URLSearchParams(window.location.search);

    let room = params.get("room");
    if (room && this.page != "Game") {
      let spectate = params.get("spectate");
      let userdata = this.userdata;
      let user = {
        id: params.get("id") || userdata.id,
        name: params.get("name") || userdata.name,
        email: params.get("email") || userdata.email,
        facebookId: params.get("facebookId") || userdata.facebookId,
        //avatar: params.get("avatar"] || userdata.avatar ),
        avatar: params.get("avatar") || userdata.avatar,
        rating: params.get("rating") || userdata.rating,
        rank: params.get("rank") || userdata.rank,
        board: params.get("board") || userdata.board,
        deck: params.get("deck") || userdata.deck,
        background: params.get("background") || userdata.background,
        serverUrl: userdata.serverUrl
      }
      if (spectate == "true") {
        this.spectateRoom(room, user);
        return;
      }
      this.joinCustomRoom(room, user);
      return;
    }


    let isLoggedIn = this.userdata && (this.userdata.id || this.userdata.email || this.userdata.facebookId);
    if (this.platform?.autoLogin === true) isLoggedIn = true;
    if (!isLoggedIn) {
      this.navigate("Login"); // will call dataLoaded() when done
      return;
    }

    //tracking
    let uuid = this.userdata.uuid;
    let mode = null;
    if (this.userdata.removeAds) mode = "RemoveAds";
    if (this.userdata.fullVersion) mode = "FullVersion";
    this.analyticsJI.setUuid(uuid);
    this.analyticsJI.setMode(mode);
    this.analyticsJI.trackStart();

    //this.analyticsFireBase.setUserProperty("fullVersion", this.userdata.fullVersion);
    //this.analyticsFireBase.setUserProperty("removeAds", this.userdata.removeAds);


    this.muteSet(this.userdata.isMuted);


    //IAP
    this.IAP.init().catch(e => console.log("IAP.init() failed", e));


    //notifications
    this.pushNotification.init().then(() => {
      //ask or register for notification if logged in
      if (this.userdata && this.userdata.id) {
        this.pushNotification.RequestPermissions(); //this will request permission if needed and get a token
      }
    });

    //log game opened
    this.userdata.game_open = (this.userdata.game_open || 0) + 1;
    if (!this.userdata.first_open) this.userdata.first_open = Date.now();

    //save os in profile
    this.userdata.os = this.device.getOS();
    this.userdata.platform = this.device.getPlatform();
    this.userdata.browser = this.device.getBrowser();
    this.userdata.version = this.version;



    //fb/portal invited to a room with getEntryPointData
    try {
      const inviteData = await this.portal.getInvite()
      if (inviteData && inviteData.room) {
        //could show popup to accept or decline, but for now just join
        this.joinCustomRoom(inviteData.room);
        return;
      }
    } catch (e) {
      console.warn("portal getInvite error", e.message);
    }


    //ask to install
    this.createShortCutTry();

    //ask to subscribeBotTry
    this.subscribeBotTry();

    //check for achievements
    this.achievements.checkForAchievementAndReward(this.userdata, this.userdata, {});


    //ask to rate / share
    this.prompter.delayedPrompt();

    this.requestTrackingAuthorizationWithExplainer();

    //todo: if setup becomes async then open ad need an updated flow.  Sometimes do no wait for advertisement.setUp to finish loading or ad a back timeout on the async call
    //todo: if remove ads, do not load ads, but what about reward ads?  look at userdata and config settings
    //let loadAds = !Boolean(this.userdata.removeAds) && !Boolean(this.userdata.fullVersion);
    //if (loadAds) {
    // this.advertisement.setUp().then(() => {
    //   ////show app open ad
    //   this.tryShowAppOpenAd().catch(e => console.log("tryShowAppOpenAd() failed", e));
    // }).catch(e => console.log("advertisement.setUp() failed", e));
    //}

    //advertisement setup for ads will happen when an ad is requested if not already done.
    //do all the ad setups need a try catch?


    //fb bot
    await this.portal.subscribeBot();


    const isBlacklistedLocal = this.blacklist.CheckLocal();
    if (isBlacklistedLocal) {
      //navigate to blacklist page
      this.navigate("Blacklist");
      return; //skip showing ads
    }
    this.blacklist.CheckRemote().then((isBlacklisted) => {
      if (isBlacklisted) {
        //navigate to blacklist page
        this.navigate("Blacklist");
      }
    });
    ////todo: swtich back to this instead of CheckLocal CheckRemote after crazy games have removed cribbage form thair portal
    // this.blacklist.Check().then((isBlacklisted) => {
    //   if (isBlacklisted) {
    //     //navigate to blacklist page
    //     this.navigate("Blacklist");
    //   }
    // });

    if (this.page != "Game") {
      await this.tryShowAppOpenAd();
      // if (this.page == "Loading") {
      //   this.tryShowAppOpenAd().finally(() => {
      //     if (this.page == "Loading")
      //       this.navigate("MainMenu");
      //   });
      // } else {
      this.navigate("MainMenu");
      //}
    }

    //debug window mode
    if (this.debug) this.showDebug();
  }
  onPrompt(message, os) {
    if (os == "FBMessenger") {
      this.showSharePopup(message);
    }
    else {
      //ask if like game then ask to rate
      this.showEnjoyGame(message);
    }
    this.rateApp.rateNative();
  }
  onPushNotificationTokenUpdated(token, deviceId) {
    if (!this.userdata) return false; //no reason to get token if no Id.
    if (!this.userdata.id) return false; //no reason to get token if no Id.
    if (!token) return false;
    if (!deviceId) return false;
    console.log("onPushNotificationTokenUpdated", token, deviceId);
    let userId = this.userdata.id;
    this.gamification.RegisterNotificationFCM(userId, token, deviceId);
  }
  onNotificationMessage(data) {
    var action = data.action;
    var room = data.room;
    var server = data.server;
    var message = data.message;
    var avatar = data.avatar;
    var userId = data.userId;
    var name = data.name;
    var coins = data.coins;
    var item = data.item;
    var url = data.url
    //try to pull room from message text [room:2134]
    if (message) {
      var matches = message.match(/\[room:(.*?)\]/);
      if (matches) {
        var submatch = matches[1];
        room = submatch;
        action = "invite";
      }
    }
    if (action === "invite") {
      let invite = {
        name: name,
        userId: userId,
        avatar: avatar,
        room: room,
        message: message
      };
      this.showInvitePopup(invite);
    }
  }
  onBackButton() {
    //check for any popups
    const dialogBoxs = document.querySelectorAll(".dialogBox");
    for (let i = 0; i < dialogBoxs.length; i++) {
      let dialogBox = dialogBoxs[i];
      if (dialogBox && dialogBox.style && dialogBox.style.display != "none" && dialogBox.style.display != "") {
        dialogBox.style.display = "none";
        return;
      }
    }
    //exit app
    if (this.page === "MainMenu") {
      this.device.exitApp();
    } else {
      this.navigate("MainMenu");
    }
    //todo: use back() when back has full back history so it can get back to menu
    if (this.test && this.test.testAutomator) {
      this.test.testAutomator.stop();
    }
  }
  back() {
    //exit app
    if (this.page === "MainMenu") {
      this.device.exitApp();
    }
    //todo: back does not pop history but rather adds to it - it also only has a 1 level deep of history , last page
    //back
    if (this.lastPage) {
      this.navigate(this.lastPage);
    } else {
      this.navigate("MainMenu");
    }
    //todo: use back() when back has full back history so it can get back to menu
    if (this.test && this.test.testAutomator) {
      this.test.testAutomator.stop();
    }
  }
  //ui page helper
  onRoute(path, pageId) {
    if (pageId == "MainMenu") {
      this.showAd();
      this.save();
      this.portal.gameStop();
    }
    if (pageId == "Level") {
      this.showAd();
      this.save();
      this.portal.gameStop();
    }
    if (pageId == "Online") {
      this.showAd();
      this.save();
    }
    if (pageId == "Game") {
      this.portal.gameStart();
    }
    this.trackPage(pageId);
  }
  get page() {
    return this.router.page;
  }
  get path() {
    return this.router.path;
  }
  get lastPage() {
    return this.router.lastPage;
  }
  navigate(path, model) {
    this.router.navigate(path, model);
  }
  populate(pageId, model) {
    const dataBinder = new DataBinder();
    dataBinder.populate(pageId, model || this);
  }
  swapPage(pageId) {
    const swapPage = new SwapPage();
    swapPage.swapPage(pageId);
  }
  translate(phrase) {
    let language = this.userdata.language;
    let translatedPhrase = this.localization.translate(phrase, language);
    return translatedPhrase;
  }

  avatarRandom() {
    if (this.items && this.items.getRandomAvatar) {
      let avatar = this.items.getRandomAvatar();
      return avatar;
    }
  }
  equipItem(name) {
    let item = this.items.getItem(name);
    if (!item) return;
    //equip it
    if (item.type === "Avatar")
      this.userdata.avatar = item.url;
    if (item.type === "Deck")
      this.userdata.deck = name;
    if (item.type === "Board")
      this.userdata.board = name;
    if (item.type === "Background")
      this.userdata.background = name;
    this.navigate('Profile');
  }
  buyItem(name) {
    let coins = this.userdata.coins || 0;
    let ownedItems = this.userdata.items || [];
    let fullVersion = this.userdata.fullVersion;
    //check if already have it (item)
    let owned = ownedItems.includes(name);
    if (owned) {
      this.equipItem(name);
    } else {
      let item = this.items.getItem(name);
      if (!item) return;
      let cost = fullVersion ? 0 : item.cost;
      //code only override
      if (item.codeOnly) {
        this.createNotification(item.message, 7);
        return;
      }
      //buy it
      if (item && cost <= coins) {
        //subtract coins
        this.userdata.coins = this.userdata.coins - cost;

        //give item
        if (!this.userdata.items) this.userdata.items = [];
        this.userdata.items.push(item.name);

        //equip it
        this.equipItem(name);

        //notification
        this.showNewItemPopup(name);
        return;
      }
      //No enough coins
      if (item && cost > coins) {
        this.createNotification("Not enough coins");
        //this.navigation('IAPMenu');
      }
    }
  }
  applyPromoCode(code) {
    const pageId = this.pageId;
    const app = this;

    if (!code) return;
    let promoItem = app.items.applyPromoCode(code, app.userdata);
    //if promoItem error, then it is an error message

    if (promoItem && promoItem.error) {
      app.createNotification(promoItem.message, 3);
      return;
    }
    if (promoItem === null) {
      app.createNotification("Invalid Promo Code", 3);
      return;
    }
    let message = "You have redeemed: " + promoItem.description;
    const item = promoItem.item;
    app.createNotification(message);
    if (item) app.showNewItemPopup(item);
    app.save(app.userdata, true);
    app.populate();
  }
  joinRandomRoomNonRanked() {
    this.joinRoom("matchroomnonranked", this.userdata);
  }
  joinRandomRoomRanked() {
    this.joinRoom("matchroom", this.userdata);
  }
  joinCustomRoom(room, userdata) {
    if (!room) return;
    if (!userdata) userdata = this.userdata
    this.joinRoom(room, userdata);
  }
  async joinRoom(room, userdata) {
    console.log("joinRoom : " + room, room)
    if (this.gameServer.isConncted())
      this.gameServer.join(room);
    else {
      try {
        let serverUrl = userdata.serverUrl;
        let value = await this.gameServer.connectAsync(userdata, serverUrl)
        this.gameServer.join(room);
      } catch (err) {
        console.error("websocket: failed to connect", err);
        this.navigate("MainMenu");
      };
    }
  }
  async spectateRoom(room, userdata) {
    console.log("spectate : " + room, room)
    if (this.gameServer.isConncted())
      this.gameServer.spectate(room);
    else {
      try {
        let serverUrl = userdata.serverUrl;
        let value = await this.gameServer.connectAsync(userdata, serverUrl)
        this.gameServer.spectate(room);
      }
      catch (err) {
        console.error("websocket: failed to connect", err);
        this.navigate("MainMenu");
      }
    }
  }
  disconnect() {
    //try to close socket connection if open
    if (this.gameServer && this.gameServer.socket)
      this.gameServer.close();
  }
  leaveNetworkGame() {
    if (this.gameServer && this.gameServer.socket)
      this.gameServer.leave();
  }
  onDisconnect() {
    //only if playing online
    if (this.path == "Game/Online" || this.page == "Online") {
      this.navigate("MainMenu");
      return;
    }
  }
  onReconnecting(message) {
    this.createNotification(message, 4, false);
  }
  onErrorNetwork(error) {
    this.createNotification("Network Error");
    //log error
    console.log("onErrorNetwork ", error);
    this.analyticsJI.trackError("onErrorNetwork", "GameServer.js", "", "", error);

    if (this.path == "Game/Online" || this.page == "Online") {
      this.navigate("MainMenu");
      return;
    }
  }
  onLoginNetwork(value) {
    //try to rejoin game
    if (value.currentRoom) {
      this.joinCustomRoom(value.currentRoom);
    }
    //if not in a game on the server but still is on the client, go to online menu
    if (!value.currentRoom && this.path == "Game/Online") {
      this.navigate("Online");
    }
  }
  onRoomNetwork(room) {
    //triggered when other players join too
    if (room) {
      this.room = room.id;
      this.spectators = room.spectators;
      this.populate("Game");
    }
  }
  onJoinRoomNetwork(room) {
    if (room) {
      this.room = room.id;
      this.spectators = room.spectators;
      this.populate("Game");
    }
  }
  onjoinGameNetwork(tablePosition) {

    this.navigate("Game/Online");
  }
  onLeaveGameNetwork() {
    //this.onlineMenu();
    this.room = null;
  }
  onMessageNetwork(value) {
    this.createNotification(value);
  }
  onUserDataNetwork(value) {
    if (!value) return;
    this.userdata.rank = value.rank;
    this.userdata.rating = value.rating;
    this.populate("Online");
  }
  onStatsNetwork(value) {
    if (!value) return;
    this.playersOnline = value.users;
    this.populate("Online");
  }
  onInviteNetwork(value) {
    //send in game invite
    let invite = {
      name: value.name,
      userId: value.userId,
      avatar: value.avatar,
      room: value.room,
      message: value.message
    };
    this.showInvitePopup(invite);
  }
  updateLevel() {
    //get user level and save update user level
    var levelNumber = this.level.getLevelFromExp(this.userdata.win);
    this.userdata.level = levelNumber;
  }
  updateAchievementProgress() {
    if (!this.achievements) return;
    if (!this.achievements.allAchievements) return;
    if (!this.userdata.achievements) return;
    //get user level and save update user level
    let total = this.achievements.allAchievements.length || 0;
    let received = this.userdata.achievements.length || 0;
    this.userdata.achievementProgress = received / total;
  }
  save(userdata, forceSave) {
    ////resume is not working, no need to save current game
    // //save current game
    // if (this.cribbage) {
    //   let currentGame = this.cribbage.save();
    //   this.currentGame = currentGame;
    //   this.storage.save("currentGame", currentGame);
    // }

    //save userdata
    if (!userdata) userdata = this.userdata;
    if (!userdata) return Promise.reject("No userdata");

    ////////track if we're overwriting better data with worse data////////
    try {
      if (!forceSave) {
        //check in background, use then instead of await so it does not delay the save, but still log if there is a potential data loss issue
        this.storage.load(this.config.storageName ?? "cribbage.userdata").then(existingData => {
          if (existingData) {
            const existingGameOpen = existingData.game_open || 0;
            const newGameOpen = userdata.game_open || 0;

            //check if existing data has more activity than new data
            if (existingGameOpen > newGameOpen) {
              console.error("DATA LOSS WARNING: Overwriting data with more activity with less activity data");
              this.analyticsJI?.trackError?.("DataLossWarning", "app.js", "save", "",
                `Existing id: ${existingData.id} game_open: ${existingGameOpen}, New id: ${userdata.id} game_open: ${newGameOpen}`);
            }
          }
        });
      }
    } catch (ex) { console.error(ex); }
    //////end track////////

    let storage = this.storage.save(this.config.storageName ?? "cribbage.userdata", userdata).catch(function () { });
    let saveServer = this.saveServer(userdata, forceSave).catch(function () { });


    let portalSaveData = this.portal.save(userdata, forceSave).catch(function () { });

    return Promise.resolve()
      .then(storage)
      .then(saveServer)
      .then(portalSaveData)
      .catch(function (ex) {
        console.log(ex);
      });
    //return Promise.all([storage, saveServer, fBSaveData]);
  }


  login(username, password) {
    console.log("Login: start");
    return this.accountJD.Login(username, password)
      .then(function (data) {
        if (!data || !data.id) return;
        if (data.id) this.userdata.id = data.id;
        if (data.name) this.userdata.name = data.name;
        if (data.email) this.userdata.email = data.email;
        if (data.facebookId) this.userdata.facebookId = data.facebookId;
        if (data.avatar) this.userdata.avatar = data.avatar;
        if (data.emailSubscribe) this.userdata.emailSubscribe = data.emailSubscribe;
        //clear password
        this.userdata.password = null;
        console.log("Login: finish");
        //todo: login or pass toke to get data from server
        return this.loadUserDataServer(data.id)
          .catch(function (reason) {
            //if no server data, load local data
            return {
              id: data.id,
              name: data.name,
              deviceId: data.deviceId,
              email: data.email,
              facebookId: data.facebookId
            };
          }.bind(this));


      }.bind(this));
  }
  async loadUserDataServer(id) {
    if (!id) id = this.userdata.id;
    //load data from server
    console.log("loadUserDataServer: start")
    const data = await this.accountJD.GetUserData(id);
    if (data) {
      console.log("loadUserDataServer: finish")
      //validate it is the right data
      if (data.id == id) {
        //set defaults
        if (!data.name) data.name = "Player" + Math.floor(Math.random() * 10000);
        this.userdata = data;
        this.populate();
      }
    }
    return data;
  }
  saveServer(userdata, forceSave) {

    if (!userdata) return Promise.reject("No userdata");
    if (!userdata.id) return Promise.reject("No user Id");

    if (!forceSave) {
      // //throttle: only after a few games played
      // let gamesPlayed = userdata.gamesPlayed || 0;
      // if (gamesPlayed <= 3) {
      //   let message = "No data sent: Not enough games played " + gamesPlayed + "/3";
      //   return Promise.resolve(message);
      // }
      //throttle: once per ... 
      let lastSync = userdata.lastSync || 0;
      let now = Date.now();
      let timeElapsed = now - lastSync;
      let minTimeElapsed = 1000 * 60 * 30; //60 minutes
      if (timeElapsed < minTimeElapsed) {
        let message = "No data sent: throttled " + timeElapsed + "/" + minTimeElapsed;
        return Promise.resolve(message);
      }
    }

    userdata.lastSync = Date.now();


    //todo: move updateUser to accountJD

    //save to server database
    //todo: updateUser in time this will only need to ping the server to update activity and not name.  
    //name and avatar wil update on the user account page.
    //update user will be for the account page not the update activity, but for now it is doing both.  It is also being used to update the avatar when equiping an item, but that could be moved to a separate call in accountJD.
    let updateUser = this.accountJD.UpdateUser(userdata).then(function () {
      console.log("Saved user data to DB")
    }).catch(function (error) { });
    //save to server file
    let saveUserData = this.accountJD.SaveUserData(userdata.id, userdata).then(function () {
      console.log("Saved user data to Backup")
    }).catch(function (error) { });

    return Promise.resolve()
      .then(updateUser)
      .then(saveUserData);
    //return Promise.all([updateUser, saveUserData]);
  }
  useItem(itemName) {
    let item = this.items.getItem(itemName);
    if (item && item.type === "Board") {
      this.userdata.board = item.name;
    }
    this.populate();
  }
  hideItemPopUp() {
    var itemPopUp = document.getElementById("itemPopUp");
    if (itemPopUp) itemPopUp.style.display = 'none';
  }
  IAPRestore() {
    return this.IAP.restore();
  }
  IAPBuy(id) {
    this.IAP.buy(id);
  }
  onIAPBuy(productId) {
    if (!productId) return;

    //log IAP
    if (!this.userdata.IAPs) this.userdata.IAPs = [];
    //duplicate IAPs are being logged for durable IAPs - clear all duplicates for that durable IAPs
    //todo: 6/13/2023 change code to only add durable IAPs once if it is not already in the list rather than removing duplicates
    //com.jdsoftwarellc.cribbage is being added for unknown reasons, remove it
    let durableIAPs = ["app.cardgames.cribbage.removeads", "app.cardgames.cribbage.fullversion", "app.cardgames.removeads", "com.jdsoftwarellc.cribbage"];
    let isProductDurable = durableIAPs.includes(productId);
    if (isProductDurable) {
      this.userdata.IAPs = this.userdata.IAPs.filter(i => i !== productId);
    }
    this.userdata.IAPs.push(productId);

    //reaward item
    if (productId === "app.cardgames.cribbage.fullversion") {
      if (this.userdata.fullVersion !== true) {
        this.createNotification("Full version granted");
      }
      this.userdata.fullVersion = true;
    }
    if (productId === "app.cardgames.cribbage.removeads") {
      if (this.userdata.removeAds !== true) {
        this.createNotification("Ads have been removed");
        this.userdata.coins = (this.userdata.coins || 0) + 2000;
        this.createNotification("Your have received 2,000 coins");
      }
      this.userdata.removeAds = true;
    }
    if (productId === "app.cardgames.cribbage.coins1000") {
      this.userdata.coins = (this.userdata.coins || 0) + 1000;
      this.createNotification("Your have received 1,000 coins");
      this.userdata.IAPs.push(productId);
    }
    if (productId === "app.cardgames.cribbage.coins5000") {
      this.userdata.coins = (this.userdata.coins || 0) + 5000;
      this.createNotification("Your have received 5,000 coins");
      this.userdata.IAPs.push(productId);
    }
    if (productId === "app.cardgames.cribbage.coins10000") {
      this.userdata.coins = (this.userdata.coins || 0) + 10000;
      this.createNotification("Your have received 10,000 coins");
      this.userdata.IAPs.push(productId);
    }
    if (productId === "app.cardgames.cribbage.coins20000") {
      this.userdata.coins = (this.userdata.coins || 0) + 20000;
      this.createNotification("Your have received 20,000 coins");
      this.userdata.removeAds = true;
      this.createNotification("Ads have been removed");
      this.userdata.IAPs.push(productId);
    }
    this.save(this.userdata, true);
    //needs a router to show and populate a page based on page logic's model
    //this.populate(); 
    if (this.page === "IAPMenu") {
      this.navigate('IAPMenu');
    }
    this.populate("MainMenu");
  }
  onNewAchievement(achievements) {
    this.showAchievementPopup(achievements);
  }
  async requestTrackingAuthorizationWithExplainer(forceShow) {
    let showExplainer = false;
    if (typeof cordova !== 'undefined' && typeof consent !== 'undefined' && cordova.platformId === 'ios') {
      const status = await consent.trackingAuthorizationStatus();
      //trackingAuthorizationStatus:  0 = notDetermined  1 = restricted 2 = denied 3 = authorized 
      if (status === 0) {
        showExplainer = true;//show explainer
      }
    }
    if (showExplainer || forceShow) {
      let model = {
        title: "Our app wants to stay free for you",
        message: "Ads help support our business. Tap “Allow” on the next screen to give permission to show ads that are more relevant to you.",
        clickAction: function () { this.requestTrackingAuthorization() }.bind(this)
      }
      this.dataBinder.createAndShow("okTemplate", model);
    }
  }
  async requestTrackingAuthorization() {
    if (typeof cordova !== 'undefined' && typeof consent !== 'undefined' && cordova.platformId === 'ios') {
      const statusNew = await consent.requestTrackingAuthorization();
    }
  }
  async showAd(force) {

    if (force) {
      await this.advertisement.setUp();
      this.advertisement.showInterstitialAd();
      return;
    }
    //fail silently
    try {
      //check if user has removed ads
      let removeAds = Boolean(this.userdata.removeAds) || Boolean(this.userdata.fullVersion);
      if (removeAds) return;

      //try show ad
      await this.advertisement.setUp();
      this.advertisement.removeAds = removeAds;
      this.advertisement.tryShowInterstitialAd();
    } catch (e) {
      console.log("showAd() error", e);
      return;
    }
  }
  async showRewardAd() {
    await this.advertisement.setUp();
    this.advertisement.showRewardedAd();
    if (!this.advertisement.adProvider) {
      this.userdata.rewardAdCount = (this.userdata.rewardAdCount || 0) + 1;
      this.createNotification("rewardAdCount = " + this.userdata.rewardAdCount);
    }
  }
  async showAppOpenAd() {
    await this.advertisement.setUp();
    this.advertisement.showAppOpenAd();
  }
  async tryShowAppOpenAd() {
    try {
      //return this.showAppOpenAd();
      //note: needs to show after user data has loaded to detect if they have removed the ads
      //1 in 5 opens
      //skip if userdata.RemovedAd = true
      //skip if first few opens
      //todo: skip if not open direct to a game "pushNotification" 
      //todo: skip if not open direct to a game via deep link

      let userdata = this.userdata;
      let showAd = true;
      let randomNumber = Math.floor(Math.random() * 4)
      let randomTurn = randomNumber === 0; //1 in 4 chance
      if (!randomTurn) showAd = false;
      if (userdata && userdata.removeAds === true) showAd = false;
      if (userdata && userdata.fullVersion === true) showAd = false;
      if (userdata && userdata.game_open < 3) showAd = false;

      if (showAd) {
        await this.advertisement.setUp();
        return this.advertisement.showAppOpenAdWithMaxDelay(4000);
      }
      else {
        console.log(`tryShowAppOpenAd is not ready - randomTurn:${randomTurn} ${randomNumber}`);
        return;
      }
    } catch (e) {
      console.log("tryShowAppOpenAd() error", e);
      return;
    }
  }
  onAdLoaded(data) {
    console.log(`onAdLoaded - ,`, data);
    //this.analytics.track("AdLoaded", data?.adType, data?.adProvider);
  }
  onAdOpened(data) {
    console.log(`onAdOpened`, data);
    //this.analytics.track("AdOpened", data?.adType, data?.adProvider);
  }
  onAdError(error, adType) {
    console.log(`onAdError - error:${error}  adType: ${adType}`);
  }
  onAdRewarded(data) {
    const adType = data.adType;
    const rewardAmount = data.rewardAmount;
    const rewardType = data.rewardType;
    console.log(`onAdRewarded - adType:${adType}  rewardAmount: ${rewardAmount} rewardType: ${rewardType}`);

    //for now, just give 150 coins per ad watched

    //reward player
    this.userdata.rewardAdCount = (this.userdata.rewardAdCount || 0) + 1;
    this.userdata.coins = (this.userdata.coins || 0) + 150;
    this.createNotification("You have received +150 coins");
    //check for reward in achievements
    this.achievements.checkForAchievementAndReward(this.userdata, this.userdata, {});
    //this.populate("WatchAndEarn");

    //repopulate current page
    if (this.page === "MainMenu") {
      this.populate("MainMenu");
    }
    if (this.page === "Board") {
      this.navigate('Board');
    }
    if (this.page === "IAPMenu") {
      this.navigate('IAPMenu');
    }
    this.save(this.userdata, true);
  }
  removeAds() {
    this.advertisement.removeAds = true;
  }
  askResume() {
    this.navigate("Resume");
    this.showAd();
  }
  blockPlayer(id, name) {
    //block player
    if (!id) return;
    if (!this.userdata.blockedPlayers) this.userdata.blockedPlayers = [];
    //if over 50 long trim oldest ones
    if (this.userdata.blockedPlayers.length > 50) {
      this.userdata.blockedPlayers.splice(0, this.userdata.blockedPlayers.length - 50);
    }
    if (this.userdata.blockedPlayers.indexOf(id) === -1)
      this.userdata.blockedPlayers.push(id);

    this.createNotification(name + " Blocked");

    ////update socket server data
    //if (this.gameServer) this.gameServer.login(this.userdata);
    if (this.gameServer && this.gameServer.socket) this.gameServer.block(id);
  }
  reportPlayer(id, name, reason) {
    //report player
    const reporterUserId = this.userdata?.id;

    this.createNotification(name + " reported" + (reason ? " for " + reason : ""));

    if (!id) return;

    this.showBlockPopup({ id, name });


    //does not exist yet
    if (this.accountJD.ReportPlayer) {
      this.accountJD.ReportPlayer(id, reporterUserId, reason);
    }
  }
  addFriend(user) {
    if (!user) return;
    if (!user.id) return;

    if (!this.userdata.friends) this.userdata.friends = [];
    let friends = this.userdata.friends;
    let existingFriends = friends.filter(function (f) {
      return f.id === (user.Id || user.id)
    });
    let friend = existingFriends[0];
    if (!friend) { //add new
      friends.push({
        id: user.id,
        avatar: user.avatar,
        name: user.name,
        facebookId: user.facebookId,
        trusted: user.trusted
      });
      this.createNotification(user.Name || user.name + " added to friends list")
    } else { //update
      friend.id = user.id;
      friend.avatar = user.avatar;
      friend.name = user.name;
      friend.facebookId = user.facebookId;
      friend.trusted = user.trusted;
    }
    //check for achievement
    this.achievements.checkForAchievementAndReward(this.userdata, this.userdata, {});
  }
  showAchievementPopup(achievements) {
    //play sound
    this.playSound("AchivementSound");
    for (var i = 0; i < achievements.length; i++) {
      let achievement = achievements[i];
      let model = {
        title: achievement.title,
        description: achievement.description,
        image: achievement.image,
        points: achievement.points
      };
      let achievementElement = this.dataBinder.create("achievementNotification", model);
      this.showNotification(achievementElement);
      //check for item
      if (achievement.item) {
        this.showNewItemPopup(achievement.item)
      }

    }
    return;
  }
  showNewItemPopup(itemName) {
    let item = this.items.getItem(itemName);
    if (!item) return;
    let modelItem = {
      title: "New Item!",
      description: item.title,
      image: item.icon
    };
    let itemElement = this.dataBinder.create("itemNotification", modelItem);
    this.showNotification(itemElement);
  }
  showEnjoyGame(message) {
    let model = {
      message: message
    }
    this.dataBinder.createAndShow("enjoyGameTemplate", model);
  }
  showAskRate(message) {
    let model = {
      message: message
    }
    this.dataBinder.createAndShow("rateAppTemplate", model);
  }
  showSharePopup(message) {
    let model = {
      message: message
    }
    this.dataBinder.createAndShow("yesNoTemplate", model);
  }
  createNotification(message, duration, playSound = true) {
    //if string then create element
    if (typeof message == "string") {
      let element = document.createElement("div");
      element.innerHTML = message;
      element.classList.add("notificationItem");
      this.showNotification(element, duration, playSound);
    }
  }

  showNotification(content, duration, playSound = true) {
    if (!duration) duration = 5;

    let notifications = document.getElementById("notifications");
    if (!notifications) return;

    //play sound
    if (playSound)
      this.playSound("PointSound");

    //create notification container
    let notification = document.createElement("div");
    notification.classList.add("notification");
    notification.style.animationDuration = duration + "s";
    notification.onclick = function () {
      this.style.display = "none";
    };
    notification.appendChild(content);

    //auto hide timer
    window.setTimeout(function () {
      notifications.removeChild(notification);
    }, duration * 1000);

    //add to list
    notifications.appendChild(notification);

  }
  showAskBlockPopup(userId, name) {
    let model = {
      message: "Do you really want to block " + name + "?",
      userId: userId,
      name: name
    }
    //copy template and populate
    let element = this.dataBinder.create("askBlockTemplate", model);
    this.showNotification(element, 10);
  }
  showInvitePopup(invite) {
    //check if friend
    let isFriend = false;
    if (this.userdata.friends) {
      if (invite) {
        let exist = this.userdata.friends.some(function (user) {
          return user.id == invite.userId;
        });
        isFriend = exist;
      }
    }
    //check if blocked
    if (!isFriend && this.userdata.blockedPlayers) {
      if (invite) {
        let exist = this.userdata.blockedPlayers.indexOf(invite.userId) !== -1;
        if (exist) {
          console.log("Blocked player invite from " + invite.userId, invite);
          return;
        }
      }
    }
    let message = invite.message;
    if (!invite.message) invite.message = "A Player has invited you to play";
    if (!invite.message && invite.name) invite.message = invite.name + " has invited you to play";
    let model = {
      message: message,
      userId: invite.userId,
      name: invite.name,
      avatar: invite.avatar,
      room: invite.room,
      isFriend: isFriend
    };

    //copy template and populate
    let element = this.dataBinder.create("inviteTemplate", model);
    this.showNotification(element, 15);
  }
  showBlockPopupWithId(userId, name) {
    this.showBlockPopup({ id: userId, name: name });
  }
  showBlockPopup(player) {
    let model = {
      userId: player.id,
      name: player.name,
      avatar: player.avatar,
      message: "Do you want to block " + player.name + " from playing you?"
    }
    //copy template and populate
    let element = this.dataBinder.create("blockTemplate", model);
    this.showNotification(element, 10);
  }
  showReportPopup(player) {
    let model = {
      userId: player.id,
      name: player.name,
      message: "Why are you reporting " + player.name + "?"
    }
    //copy template and populate
    let element = this.dataBinder.create("reportTemplate", model);
    this.showNotification(element, 10);
  }
  hide(elementId) {
    var element = document.getElementById(elementId);
    element.style.display = "none";
  }
  playSound(id) {
    this.audio.play(id);
  }
  muteSet(isMuted) {
    this.audio.muteSet(isMuted);

    this.isMuted = isMuted;
    this.userdata.isMuted = isMuted;

  }
  muteToggle() {
    this.isMuted = !this.isMuted;
    this.muteSet(this.isMuted);

    this.populate("MainMenu");

    return this.isMuted;
  }
  mail() {
    this.achievements.awardAchivement(this.userdata, 'Send Feedback');
    this.emailFeedback.send(this.userdata);
  }
  rate() {
    this.achievements.awardAchivement(this.userdata, 'Rate Game');
    const results = this.rateApp.rate();

    if (!results) {
      this.share();
    }
    this.trackEvent("Rate");
  }
  newsLoad() {
    return this.gamification.News()
      .then((data) => {
        this.news = data;
        this.populate();
      });
  }
  showGame(app) {
    this.marketPlace.show(app);
    this.trackEvent("MoreGames/" + app);
  }
  share() {
    this.sharer.share();
    this.trackEvent("Share");
  }
  subscribeBotTry() {
    if (this.userdata) {
      if (this.userdata.game_open === 2
        || this.userdata.game_open === 10
        || this.userdata.game_open === 50) {
        this.subscribeBot();
      }
    }
  }
  subscribeBot() {
    this.portal?.subscribeBot?.();
  }
  createShortCutTry() {
    if (this.userdata) {
      if (this.userdata.game_open === 5
        || this.userdata.game_open === 30
        || this.userdata.game_open === 100) {
        this.createShortCut();
      }
    }
  }
  createShortCut() {
    this.portal?.createShortCut?.();
  }


  async autoLogin() {
    let userdata = this.userdata;
    if (!userdata) return;
    //give fake email for now
    const platform = this.portal.platform;
    if (!userdata.email) userdata.email = `${platform}_${userdata.name || ''}_${Math.floor(Math.random() * 1000000)}@crazygames.com`;
    console.log("accountJD.Register - autoLogin()");
    const data = await this.accountJD.Register(this.userdata);

    if (data.id) {
      this.userdata.id = data.id;
      return true;
    }
    return false;
  }
  updateAvatarToServer(suffix) {
    if (!this.userdata.id) return;
    if (!this.userdata.avatar) return;
    if (this.userdata.avatar.indexOf('crazygames') !== -1 || this.userdata.avatar.indexOf('instantgames') !== -1)
      //save avatar image on server and set
      this.accountJD.UploadAvatarUrl(this.userdata.id + (suffix || ""), this.userdata.avatar).then((url) => {
        if (url) {
          this.userdata.avatar = url;
        }
      });
  }
  showDebug() {
    //debug window
    window.document.getElementById("debug").style.display = "block";
  }
  trackPage(pageId) {
    //this.analyticsFireBase.trackPage(pageId);
  }
  trackEvent(event) {
    //this.analyticsFireBase.trackPage(event);
  }
  trackError(error) {
    this.analyticsJI.trackError("onErrorNetwork", "GameServer.js", "", "", error);
  }
}